const renewalStatus = {
    INACTIVE : 0,

    RENEWAL_PENDING : 1,

    NON_RENEWAL_PENDING : 3,

    FLAGGED_FOR_NON_RENEWAL : 4

};

angular.module('gw-um-j2js')
    .constant('renewalStatus', renewalStatus);